import { render, staticRenderFns } from "./instApproveDemandEasy.vue?vue&type=template&id=55151be8&scoped=true"
import script from "./instApproveDemandEasy.vue?vue&type=script&lang=js"
export * from "./instApproveDemandEasy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55151be8",
  null
  
)

export default component.exports